import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UserSessionService, getDateObj, getNgBsObj } from '../../shared';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ToastService } from '../../blocks/toast/toast.service';
import { ModalService } from '../../blocks/modal/modal.service';
import { EmrPatHistory } from '../medical-recored.interfaces';
import { MedicalControllerService } from '../medical-controller.service';
import { MedicalRepositoryService } from '../medical-repository.service';

@Component({
  selector: 'emr-chronic',
  templateUrl: './emr-chronic.component.html',
  styleUrls: ['./emr-chronic.component.css']
})
export class EmrChronicComponent implements OnInit, OnDestroy {
  // unsubscribe obj
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  // input
  _docId: number;
  @Input() set docId(value: number) {
    this._docId = value;
  }

  // properties
  visitSerial: number;
  emrChronicData: EmrPatHistory[] = [];
  editChronicData: EmrPatHistory = <EmrPatHistory>{};
  chronicForm: UntypedFormGroup;
  editableContent: boolean;
  @Input() addNewChronic: boolean;
  // constractor
  constructor(
    public translate: TranslateService,
    private _modalService: ModalService,
    private _toastService: ToastService,
    private _userSessionService: UserSessionService,
    private _medicalRepo: MedicalRepositoryService,
    private _medicalControl: MedicalControllerService) {
    _medicalRepo.reloadSubscription = _medicalRepo._reloadClick.subscribe(res => {
      if (res && res == 'Allergy')
        this.getEmrPatChronicData(_medicalRepo.VisitSerial);
    });
  }

  // angular lifecycle
  ngOnInit() {
    this.InitChronicForm();
    this.visitData$();
  }

  ngOnDestroy() {
    this._medicalRepo.reloadSubscription.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  // methods
  InitChronicForm() {
    this.chronicForm = new UntypedFormGroup({
      serial: new UntypedFormControl(),
      visitSerial: new UntypedFormControl(),
      historycode: new UntypedFormControl(),
      historyText: new UntypedFormControl(),
      type: new UntypedFormControl(),
      startDate: new UntypedFormControl(),
      endDate: new UntypedFormControl(),
      notes: new UntypedFormControl(),
      family: new UntypedFormControl(),
      past: new UntypedFormControl()
    });
  }


  visitData$() {
    this._userSessionService.subscribeToKey$('visitData')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.visitSerial = keys.value.serial ? keys.value.serial :0;
          this.editableContent = keys.value.editableContent;
          this.getEmrPatChronicData(this.visitSerial);
        }
      });
  }

  newChronic() {
    this.chronicForm.reset();
  }

  getEmrPatChronicData(vSerial: number) {
    this._medicalControl.getEmrPatHistory(vSerial)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          this.emrChronicData = res ? res.data : [];
        },
        error => console.log(error),
        () => {
          if (this.emrChronicData && this.emrChronicData.length > 0) {
            this.emrChronicData = this.emrChronicData.filter(el => el.type == 3);
          }
        });
  }

  onClicked(e: number, itemData: EmrPatHistory): void {
    switch (e) {
      case 1:
        this.save();
        break;
      case 402:
        this.patchDataToForm(itemData);
        break;
      case 403:
        this.delete(itemData);
      default:
        console.log('Nothing');
    }
  }

  patchDataToForm(rowData: EmrPatHistory) {
    if (rowData) {

      this.chronicForm.patchValue(rowData);
      this.chronicForm.get('historycode').setValue(rowData.historycode);
      this.chronicForm.get('startDate').setValue(getNgBsObj(rowData.startDate));
      this.chronicForm.get('endDate').setValue(getNgBsObj(rowData.endDate));
    }
  }

  save() {
    this.editChronicData = this.chronicForm.value;
    this.editChronicData.type = 3;
    this.editChronicData.startDate = getDateObj(this.chronicForm.get('startDate').value);
    this.editChronicData.endDate = getDateObj(this.chronicForm.get('endDate').value);
    this.editChronicData.visitSerial = this.visitSerial;
    if (this.addNewChronic == true) {
      this.editChronicData.serial = 0;
      this._userSessionService.setSessionKey('PatientNewChronic', this.editChronicData);

    }

    else {
      if (this.editChronicData.serial == (undefined || null) && this.editChronicData.visitSerial == (undefined || null)) {
        this._toastService.activateMsg('UI44');
        return false;
      }

      if (this.editChronicData.serial > 0) {
        this._medicalControl.updateEmrPatHistory(this.editChronicData)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(c => {
            if (c && c.returnFlag) {
              this.chronicForm.reset();
              this.getEmrPatChronicData(this.visitSerial);
              this._userSessionService.closeModalKey('MedicalDataPopupComponent', { closedTap: 'Chronic' });
            }
          });
      }
      else {
        this.editChronicData.serial = 0;
        this._medicalControl.addEmrPatHistory(this.editChronicData)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(c => {
            if (c && c.returnFlag) {
              this.chronicForm.reset();
              this.getEmrPatChronicData(this.visitSerial);
              this._userSessionService.closeModalKey('MedicalDataPopupComponent', { closedTap: 'Chronic' });
            }
          });
      }
    }
  }

  delete(rowData: EmrPatHistory) {
    this._modalService.activeDelMes(rowData.serial.toString(), rowData.serial.toString()).then(responseOK => {
      if (responseOK) {
        this._medicalControl.deleteEmrPatHistory(rowData)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(c => {
            if (c)
              this.getEmrPatChronicData(this.visitSerial);
          });
      }
    });
  }

}
